import React, { memo } from "react";
import styles from "../Tickets.module.css"
import moment from 'moment'
import 'moment/locale/ru'

const normalizeTicketStatus = (ticket) => {
    const raw =
        ticket?.status?.name ||
        ticket?.status?.title ||
        ticket?.status_name ||
        ticket?.state ||
        ticket?.state_name ||
        ticket?.ticket_state ||
        ticket?.ticket_status?.name ||
        ticket?.ticket_status?.title ||
        ticket?.ticket_status ||
        null;

    if (raw) return String(raw);

    // If backend doesn't provide explicit status, derive it from messages.
    if (ticket?.closed) return 'закрыт';

    const messages = Array.isArray(ticket?.messages) ? ticket.messages : [];
    if (messages.length <= 1) return 'новый';

    const last = messages[messages.length - 1];
    const authorId = last?.user_id;
    const requesterId = ticket?.user_id || ticket?.author_id || ticket?.created_by;

    // If the requester is the last author, user is waiting for operator response.
    if (requesterId != null && authorId === requesterId) {
        return 'ожидает ответа';
    }

    // Otherwise assume there is a new answer from operator/moderator.
    return 'есть ответ';
};

// Same color logic as applications
const getStatusStyle = (statusLabel, isClosed) => {
    const normalized = statusLabel?.toLowerCase() || '';

    // отказ (rejection/refusal) - light red
    if (
        normalized.includes('отказ') ||
        normalized.includes('отказан') ||
        normalized.includes('отклон') ||
        normalized.includes('не соглас') ||
        normalized.includes('не принято')
    ) {
        return { backgroundColor: '#FFE5E3', color: '#EF2E25' };
    }

    // принято (accepted) - light green
    if (normalized.includes('принято') || normalized.includes('принят')) {
        return { backgroundColor: '#E2EEDD', color: '#A1C261' };
    }

    // в работе (in progress) - light blue
    if (normalized.includes('в работе') || normalized.includes('работа') || normalized.includes('обработ')) {
        return { backgroundColor: '#E8EFFB', color: '#2F6FED' };
    }

    // новый / ожидает ответа - keep it noticeable
    if (normalized.includes('нов')) {
        return { backgroundColor: '#E8EFFB', color: '#2F6FED' };
    }
    if (normalized.includes('ожида')) {
        return { backgroundColor: '#FFE8E3', color: '#F36D52' };
    }
    if (normalized.includes('ответ')) {
        return { backgroundColor: '#E2EEDD', color: '#A1C261' };
    }

    // на доработку (needs revision) - light orange
    if (normalized.includes('доработ')) {
        return { backgroundColor: '#FFE8E3', color: '#F36D52' };
    }

    // закрыт (closed) - light grey
    if (normalized.includes('закры') || isClosed) {
        return { backgroundColor: '#F4F4F4', color: '#8F9191' };
    }

    // Default - light green
    return { backgroundColor: '#E2EEDD', color: '#A1C261' };
};

const Ticket = ({ ticket }) => {
    const date = moment(ticket.messages[0].created_at).format('DD MMM YYYY')
    const statusLabel = normalizeTicketStatus(ticket);
    const statusStyle = getStatusStyle(statusLabel, !!ticket.closed);
    return (
        <div className={styles.ticketItem}>
            <div className={styles.number}>#{ticket.id}</div>
            <div className={styles.textContent}>
                <h2 className={styles.title}>
                    {ticket.name}
                </h2>
                <div>
                    <span
                        className={styles.statusPill}
                        style={statusStyle}
                    >
                        {statusLabel}
                    </span>
                    {/* <span style={{ marginRight: '11px', color: '#73982C', backgroundColor: '#fff' }} className="status">новый</span> */}
                    <span className="time">{date}</span>
                </div>
            </div>
        </div>
    )
}
export default memo(Ticket)
